export function UrlApi(api) {
  const arr = [];

  arr["ws_host"] = "https://sandbox.sbm24.net/";

  arr["base_URL"] = "https://sandbox.sbm24.net/api/";
  arr["login"] = arr["base_URL"] + "v1/login";
  arr["secretary_login"] = arr["base_URL"] + "v2/secretary/auth";
  arr["register_confirm"] = arr["base_URL"] + "v1/register/confirm";
  arr["register_confirm_resend"] =
    arr["base_URL"] + "v1/register/confirm/resend";
  arr["register_confirm_set"] = arr["base_URL"] + "v1/register/confirm/set";
  arr["reset_password_confirm"] = arr["base_URL"] + "v1/password/reset/confirm";
  arr["nationalcode"] = arr["base_URL"] + "v1/register/nationalcode";
  arr["register"] = arr["base_URL"] + "v1/register/create-account";
  arr["reset_password"] = arr["base_URL"] + "v1/password/reset/change";

  arr["get_start"] = arr["base_URL"] + "v1/user/get_start";

  arr["pusher"] = arr["base_URL"] + "v1/user/pusher/auth";
  arr["chat"] = arr["base_URL"] + "v1/user/chat";
  arr["chat_seen"] = arr["base_URL"] + "v1/user/chat/seen";
  arr["broadcasting"] = arr["base_URL"] + "v1/broadcasting/auth";
  arr["delete_chat"] = arr["base_URL"] + "v1/user/chat/delete/";

  arr["medical_history"] = arr["base_URL"] + "v1/user/medical-history/info";
  arr["medical_history_set"] = arr["base_URL"] + "v1/user/medical-history/set";

  arr["user_profile"] = arr["base_URL"] + "v1/user/profile";
  arr["user_avatar"] = arr["base_URL"] + "v1/user/profile/avatar";

  arr["city"] = arr["base_URL"] + "v1/user/city";
  arr["increase_credit"] = arr["base_URL"] + "v1/user/increase/credit";
  arr["entery_data_user"] =
    arr["base_URL"] + "v2/user/profile/update?_method=PATCH";
  arr["entery_data_dr"] =
    arr["base_URL"] + "v2/doctor/profile/update?_method=PATCH";

  arr["reserve"] = arr["base_URL"] + "v1/user/visit/reserve";
  arr["dossier"] = arr["base_URL"] + "v1/user/visit/dossier";
  arr["meeting_user"] = arr["base_URL"] + "v1/user/visit/meeting";
  arr["FileSend"] = arr["base_URL"] + "v2/message/send";
  arr["meeting_user_single"] = arr["base_URL"] + "v1/user/visit/meeting/single";

  arr["user_transaction"] = arr["base_URL"] + "v1/user/transaction/reserve";
  arr["user_refund"] = arr["base_URL"] + "v2/user/refund/store";

  arr["doctor_dossier"] = arr["base_URL"] + "v1/doctor/visit/dossier";
  arr["doctor_exp"] = arr["base_URL"] + "v2/visit/doctor/dossier";
  arr["doctor_info"] = arr["base_URL"] + "v1/doctor/profile/info";

  arr["calender"] = arr["base_URL"] + "v1/doctor/calender";
  arr["online_calender"] = arr["base_URL"] + "v1/doctor/calender/online";
  arr["off_calender"] = arr["base_URL"] + "v1/doctor/calender/offline";
  arr["meeting_dr"] = arr["base_URL"] + "v1/doctor/visit/meeting";
  arr["doctor_profile"] = arr["base_URL"] + "v1/doctor/profile";
  arr["visit_price"] = arr["base_URL"] + "v2/calendar/update";
  arr["not_end_meeting_dr"] = arr["base_URL"] + "v2/visit/doctor/list";
  arr["all_meeting_dr"] = arr["base_URL"] + "v2/visit/doctor/list/all";

  arr["video_call_create"] = arr["base_URL"] + "v1/doctor/visit/video/create";
  arr["video_call_connect"] = arr["base_URL"] + "v1/user/visit/video/connect";
  arr["dr_video_call_rate"] = arr["base_URL"] + "v1/doctor/visit/video/rate";
  arr["user_video_call_rate"] = arr["base_URL"] + "v1/user/visit/video/rate";
  arr["video_call_request"] = arr["base_URL"] + "v1/user/visit/video/request";
  arr["new_video_call_request"] = arr["base_URL"] + "v2/bb/create";
  arr["binjoo_video_call_request"] = arr["base_URL"] + "v2/binjoo/request";

  arr["user_medical_history"] =
    arr["base_URL"] + "v1/doctor/visit/user/medical-history";
  arr["dr_prescription"] = arr["base_URL"] + "v1/doctor/visit/prescription";
  arr["FinalVisit"] = arr["base_URL"] + "v1/doctor/visit/finish";
  arr["CancelVisit"] = arr["base_URL"] + "v1/doctor/visit/cancel";
  arr["doctor_transaction"] = arr["base_URL"] + "v1/doctor/transaction/reserve";
  arr["doctor_paid_transaction"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?status=paid";

  arr["cansel_action"] = arr["base_URL"] + "v2/visit/actions/store";

  arr["doctor_setting"] = arr["base_URL"] + "v2/user/setting";
  arr["get_doctor_setting"] = arr["base_URL"] + "v2/user/get-settings";

  arr["doctor_paid_transaction_lastweek"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?status=paid&week=1";
  arr["doctor_paid_transaction_currentmonth"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?status=paid&week=2";
  arr["doctor_paid_transaction_lastmonth"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?status=paid&week=3";

  arr["doctor_transaction_lastweek"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?week=1";
  arr["doctor_transaction_currentmonth"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?week=2";
  arr["doctor_transaction_lastmonth"] =
    arr["base_URL"] + "v1/doctor/transaction/reserve?week=3";
  arr["doctor_transaction_overView"] =
    arr["base_URL"] + "v1/doctor/transaction/overview";
  arr["doctor_transaction_chart"] =
    arr["base_URL"] + "v1/doctor/transaction/chart";

  arr["affiliate-transactions"] =
    arr["base_URL"] + "v2/affiliate/affiliate-transactions";

  arr["doctor-log"] = arr["base_URL"] + "v1/doctor/visit/left-the-room";
  arr["doctor-visit-duration"] = arr["base_URL"] + "v1/doctor/visit/duration";

  arr["twilio_connection"] = arr["base_URL"] + "v1/pusher/twilio";

  arr["doctor_open_room"] = arr["base_URL"] + "v1/doctor/open-room";
  arr["user_open_room"] = arr["base_URL"] + "v1/user/open-room";

  arr["create_skill"] = arr["base_URL"] + "v1/doctor/profile/create_skill";

  arr["sk_create"] = arr["base_URL"] + "v1/visit-room/create/";
  arr["voice_create"] = arr["base_URL"] + "v1/visit-room/voice/";
  arr["sk_join"] = arr["base_URL"] + "v1/visit-room/join/";

  arr["rate_patient"] = arr["base_URL"] + "v1/rate/store";
  arr["absent_dr"] =
    arr["base_URL"] + "v1/user/visit/meeting/absence-of-doctor";

  arr["loginv2"] = arr["base_URL"] + "v2/authenticate/login";

  arr["login_v2"] = arr["base_URL"] + "v2/authenticate/send-confirmation-code";
  arr["validate_v2"] = arr["base_URL"] + "v2/authenticate/validate-code";
  arr["signOut"] = arr["base_URL"] + "v2/authenticate/logout";

  if (arr[api]) {
    return arr[api];
  }

  return "null";
}

export function webConfig(config) {
  const arr = [];

  arr["web_key"] = "sbm24";
  arr["web_name"] = "سلامت بدون مرز";
  arr["web_slogan"] = "سامانه مجازی مشاوره های پزشکی و بالینی";
  arr["info_site"] = "https://sbm24.com/";
  arr["cookie_key"] = "sbm24.com";
  // arr["cookie_key"] = "localhost";

  if (arr[config]) {
    return arr[config];
  }

  return "null";
}
